import { TripDetailConstant } from "./TripDetailConstant";


const TripDetailAction = {};

TripDetailAction.getTripDetailData = ({to_date,from_date,search_term,limit,page,trip_status}) => {
    console.log('ehfgeu',trip_status);
    
   
    return {
        type: TripDetailConstant.TRIP_DETAIL_SAGA, 
        payload: {
            to_date:to_date,
            from_date:from_date,
            search_term:search_term,
            limit:limit,
            page:page,
            trip_status:trip_status,
        }
    }
};


export { TripDetailAction };